var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-bg list-item"},[_c('strong',[_vm._v(_vm._s(_vm.dataInfo.name))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.dataInfo.phone))])])}
var staticRenderFns = []

export { render, staticRenderFns }